import { render, staticRenderFns } from "./Playerlisting.vue?vue&type=template&id=7570e2f6&scoped=true&"
import script from "./Playerlisting.vue?vue&type=script&lang=js&"
export * from "./Playerlisting.vue?vue&type=script&lang=js&"
import style0 from "./Playerlisting.vue?vue&type=style&index=0&id=7570e2f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570e2f6",
  null
  
)

export default component.exports